import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";
import { Provider } from "react-redux";
import { store } from "./store";
import "./i18n"; // Import i18n configuration
import AppRoutes from "./routes";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { VoiceAgentDataProvider } from "./context/VoiceAgentDataProvider";
import { theme } from "./theme";
import WidgetPage from "./pages/WidgetPage";
import ProtectedRoute from "./components/ProtectedRoute";
import FullScreenLoader from "./components/FullScreenLoader";

function AppContent() {
  const { loading } = useAuth();
  if (loading) {
    return <FullScreenLoader />;
  }
  return (
    <VoiceAgentDataProvider>
      <Routes>
        <Route
          path="/widgets"
          element={
            <ProtectedRoute roles={["user", "admin", "superadmin"]}>
              <WidgetPage />
            </ProtectedRoute>
          }
        />
        <Route path="/*" element={<AppRoutes />} />
      </Routes>
    </VoiceAgentDataProvider>
  );
}

function App() {
  return (
    <Provider store={store}>
      <ChakraProvider theme={theme}>
        <Router>
          <ThemeProvider>
            <AuthProvider>
              <AppContent />
            </AuthProvider>
          </ThemeProvider>
        </Router>
      </ChakraProvider>
    </Provider>
  );
}

export default App;
